import { CloudSDK } from "@sitecore-cloudsdk/core/browser";
import "@sitecore-cloudsdk/events/browser";
import "@sitecore-cloudsdk/personalize/browser";
//import "@sitecore-cloudsdk/search/browser";
import { pageView, PageViewData } from "@sitecore-cloudsdk/events/browser";
import { BrowserSettings } from "@sitecore-cloudsdk/core/internal";
import { awaitConsentStatistic, hasConsentMarketing, hasConsentStatistic } from "./consents";

function initCloudSdk(
    sitecoreEdgeContextId: string,
    siteName: string,
    page: string,
    pageVariantId: string
) {
    console.log(
        `Initializing CloudSDK ${sitecoreEdgeContextId} for ${siteName}`
    );

    const enableBrowserCookie = hasConsentStatistic();
    const personalization = hasConsentMarketing();

    const settings: BrowserSettings = {
        siteName,
        enableBrowserCookie: enableBrowserCookie,
        sitecoreEdgeContextId,
    };
    const sdk = CloudSDK(settings);

    // Verify that dynamic prototype pattern is working
    if (sdk.addEvents) {
        sdk.addEvents();
    } else {
        console.warn("Missing CloudSDK addEvents method, missing sideeffect");
    }

    // Initialize the personalize package
    if (personalization && sdk.addPersonalize) {
        sdk.addPersonalize({
            enablePersonalizeCookie: personalization,
            webPersonalization: personalization,
        });
    }
    // This breaks the JS for now so commenting out
    // sdk.addSearch();

    // Run the initialization logic and set cookies
    sdk.initialize();

    // Track this page view
    if (enableBrowserCookie) {
        const htmlElm = document.querySelector("html");
        const language = htmlElm?.getAttribute("lang");

        const data: PageViewData = {
            channel: "WEB",
            currency: "DKK",
            language: language ?? undefined,
            page,
            pageVariantId,
        };
        pageView(data);
    }
}

export default function init() {
    const json = document.querySelector("script#cfg")?.innerHTML;
    if (!json) {
        return;
    }

    const { id, name, key, itm } = JSON.parse(json);
    if (!id) {
        console.log(
            "Not running with XM Cloud Edge Context, so skipping Cloud SDK"
        );
        return;
    }

    awaitConsentStatistic().then(() => initCloudSdk(id, name, key, itm));
}
